import { Flex, Form, FormInstance, Input, Select } from 'antd';
import { commonFieldRules, inputFieldRules } from '../../../error/antdRules';
import {
  fieldIsRequiredText,
  inputToLongText,
} from '../../constants/constants';
import { supComplexDisorders } from '../../constants/sup';
import { selectHerePlaceholder } from '../../constants/translations';

export const SupSubGroup = ({
  form,
  selectionOptions,
}: { form: FormInstance; selectionOptions: string[] }) => {
  const selectedSupGroup = Form.useWatch(['registration', 'supSubGroup'], form);

  const isSupSubGroupComplex = selectedSupGroup === supComplexDisorders;

  const inputMaxLength = 300;

  return (
    <Flex vertical>
      <Form.Item
        label="SUP grupės tipai"
        name={['registration', 'supSubGroup']}
        style={{ display: selectionOptions?.length > 0 ? 'block' : 'none' }}
      >
        <Select placeholder={selectHerePlaceholder} showSearch={true}>
          {selectionOptions?.map((item, index) => (
            <Select.Option key={`selector_item_${index + 1}`} value={item}>
              {item}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      {isSupSubGroupComplex && (
        <Form.Item
          label={false}
          name={['registration', 'supSubGroupInput']}
          rules={[
            commonFieldRules.fieldIsRequired(fieldIsRequiredText),
            inputFieldRules.fieldInputTooLong(inputToLongText, inputMaxLength),
          ]}
        >
          <Input.TextArea
            rows={2}
            placeholder={'Įrašyti'}
            allowClear
            count={{
              show: true,
              max: inputMaxLength,
            }}
          />
        </Form.Item>
      )}
    </Flex>
  );
};
